import styled from "styled-components";

export const IntFieldBox = ({isFocused = false, isError = false, children, onClick = () => {}, ...props}) => {

  return <FieldBox isFocused={isFocused} isError={isError}  data-element={'int-field-box'} onClick={onClick} {...props}>
    {children}
  </FieldBox>
}

const FieldBox = styled.div`
  transition: all .2s ease;
  border: 0.0625rem solid var(--int-box-border-color, #aaa);
  padding: 0;
  box-shadow: 0 0 0 2px ${props => (props.isFocused && !props.isError)
    ? 'var(--int-field-box-focused-color, blue)' 
    : props.isError 
    ? 'var(--int-field-box-error-color, red)!important' 
    : 'transparent'};
  border-radius: 0.25rem;
`;